import { colors } from "../colors";
import csiColorBar from "./csiColorBar.png";

let swsPlotColorBarOptions = {
  chart: {
    type: "line",
    backgroundColor: null,
    plotBackgroundImage: csiColorBar,
    animation: false,
    plotBorderWidth: 0,
    width: 85,
  },
  credits: {
    enabled: false,
  },
  title: {
    text: null,
  },
  yAxis: {
    title: {
      text: "Depth (mm)",
      margin: 5,
      useHTML: true,
      style: {
        color: colors.chartAxisLabel,
      },
    },
    labels: {
      format: "{value}",
      x: 6, //label position relative to the axis
      style: {
        color: colors.chartAxisLabel,
      },
    },
    startOnTick: false,
    endOnTick: false,
    min: 0,
    max: 15,
    tickWidth: 1,
    lineWidth: 1, // y-axis line
    tickLength: 5,
    gridLineWidth: 0,
    minorGridLineWidth: 0,
    tickPixelInterval: 25,
    allowDecimals: false,
    opposite: true,
  },
  xAxis: {
    title: {
      text: "Frame",
      offset: 20,
      style: {
        color: colors.chartAxisLabel,
      },
      useHTML: true,
    },
    labels: {
      format: "{value}",
      rotation: 1, // had to add 1 degree rotation or else the labels "did not fit" and highcharts wouldnt show them
      y: 20, //position label relative to tick line
      style: {
        color: colors.chartAxisLabel,
      },
    },
    // startOnTick: true,
    // endOnTick: true,
    min: -60,
    max: 0,
    allowDecimals: false,
    // tickAmount: 2,
  },
  legend: {
    enabled: false,
  },
  series: [
    {
      name: "Bmode",
      type: "line",
      borderWidth: 0,
      animation: false,
      nullColor: colors.chartNullColor,
      tooltip: {
        enabled: false,
      },
    },
  ],
};

export { swsPlotColorBarOptions };
